import { Dispatch, SetStateAction, JSX } from 'react';
import { InteractiveDiv } from '@Components/InteractiveEl';
import cn from 'classnames';
import { Neutral200 } from '@src/utils/colors';
import './MarketingOutcomesLegend.scss';
import { TotalHolisticRevenueColor, ROASColor, InactiveTextColor } from '../utils/colors'; // inlined from former TVADCrossChannel/homePageConstants
import { EfficientFrontierSeries } from '../utils/efficientFrontierUtils';

const INACTIVE_COLOR = Neutral200;

interface MarketingOutcomesLegendProps {
  series: EfficientFrontierSeries[];
  selectedModels: Set<string>;
  setSelectedModels: Dispatch<SetStateAction<Set<string>>>;
}

export const MarketingOutcomesLegend = ({
  series,
  selectedModels,
  setSelectedModels
}: MarketingOutcomesLegendProps): JSX.Element => {
  const handleLegendClick = (area: string) => {
    setSelectedModels(prev => {
      const newSet = new Set(prev);
      if (newSet.has(area)) {
        newSet.delete(area);
      } else {
        newSet.add(area);
      }
      // Ensure at least one model is selected
      if (newSet.size === 0) {
        newSet.add(area);
      }
      return newSet;
    });
  };

  return (
    <div className='ef-marketing-outcomes-legend'>
      <div className='ef-legend-title-wrapper revenue'>
        <div
          className={cn('legend-icon', 'simple-icon', {
            dash: true
          })}
          style={{
            backgroundColor: TotalHolisticRevenueColor
          }}
        />
        <div className='legend-label'>Revenue</div>
      </div>
      <div className='simple-legend-container'>
        <div className='simple-legend'>
          {series.map(item => {
            const itemValue = item.id;
            const isActiveItem = selectedModels.has(itemValue);
            const activeColor = isActiveItem ? item.color : INACTIVE_COLOR;

            return (
              <InteractiveDiv
                className='simple-legend-item'
                key={itemValue}
                onClick={() => handleLegendClick(itemValue)}
              >
                <div className='legend-value'>
                  <div className={cn({ 'inactive-legend': !isActiveItem })}>
                    <div className='legend-icon-wrapper'>
                      <div
                        className={cn('legend-icon', 'simple-icon', {
                          active: isActiveItem
                        })}
                        style={{
                          backgroundColor: isActiveItem ? activeColor : INACTIVE_COLOR
                        }}
                      />
                      <div
                        className='legend-label'
                        style={isActiveItem ? {} : { color: InactiveTextColor }}
                      >
                        {item.label}
                      </div>
                    </div>
                  </div>
                </div>
              </InteractiveDiv>
            );
          })}
        </div>
      </div>
      <div className='ef-legend-title-wrapper roas'>
        <div
          className={cn('legend-icon', 'simple-icon', {
            dash: true
          })}
          style={{
            backgroundColor: ROASColor
          }}
        />
        <div className='legend-label'>ROAS</div>
      </div>
    </div>
  );
};
